module.exports = __webpack_public_path__ + "img/success.ef6cabe1.png";